module.exports = __webpack_public_path__ + "static/media/icon-bottom-home.98146925.svg";